var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5608 12.5598C13.1465 11.9739 13.1464 11.0241 12.5605 10.4384L3.01303 0.894009C2.42715 0.308316 1.4774 0.308466 0.891709 0.894345C0.306015 1.48022 0.306166 2.42997 0.892045 3.01567L9.37867 11.4996L0.894733 19.9862C0.309039 20.5721 0.30919 21.5219 0.895069 22.1075C1.48095 22.6932 2.4307 22.6931 3.01639 22.1072L12.5608 12.5598ZM8.00023 12.9998L11.5002 12.9993L11.4998 9.99927L7.99975 9.99982L8.00023 12.9998Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationRight);
export default __webpack_public_path__ + "static/media/paginationRight.5a4696f21a5ccc07f893c0642f4aa3de.svg";
export { ForwardRef as ReactComponent };